/**
 * ═══════════════════════════════════════════════════════════════════════════
 * EL COPY DE LA LANDING
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * 15/09/2026 · SE REESCRIBE OTRA VEZ, CON EL REPASO DEL DUEÑO SOBRE CAPTURAS.
 *
 * La versión del 14/09 (commit `ae73324`, por si hay que recuperar un párrafo)
 * tenía el hilo bien pensado y los textos mal escritos. Sus palabras:
 *
 *   · «la landing tiene que tener un storytelling, contado de arriba hacia
 *     abajo, y a cada scroll profundizar en esa historia, hasta llegar al
 *     final y ser natural la persona querer mucho hacer la suscripción».
 *   · Sobre «Te decimos de dónde sale cada número · 134 de los 255 ejercicios
 *     llevan detrás una fuente publicada…»: «no pongamos dudas sobre lo que
 *     tenemos, pareciera que estamos pidiendo disculpas». Fuera.
 *   · Sobre «Por qué Voice Comfort»: «todos en menor o mayor grado no se
 *     entienden». Reescritos: qué es, en una frase, y qué ganas.
 *   · Sobre «Antes de que pagues» («Nunca te decimos qué tienes», «Y
 *     preferimos perder la venta»): «no parece que fue escrito por un
 *     profesional… como si al usuario eso le fuera a importar». Pasa a ser
 *     «Tu seguridad, primero», contado desde lo que la persona gana.
 *   · «Sin tarjeta y sin cuenta»: «es mentira, la persona tiene que suscribirse
 *     para poder ingresar a la plataforma a hacer su plan de ejercicios. Lo que
 *     sí es verdad es que damos 14 días de garantía». Fuera de toda la página;
 *     la garantía pasa al frente.
 *   · Y la dirección postal del pie: «quita eso».
 *
 * ── LO QUE NO CAMBIA, PORQUE NO ES ESTILO SINO LEY Y POLÍTICA ─────────────
 *
 *   · «Previene lesiones vocales» sigue PROHIBIDA (`H002`), y comparar el
 *     precio con una consulta profesional también (RD 1907/1996 art. 4.15).
 *   · Toda cifra de dos dígitos sale de `cifras.ts`: «catorce días» va en
 *     letra porque 14 no es una cifra del catálogo (`verificar:copy`).
 *   · El bloque de precio: lanzamiento fijo, sin subida (06/10/2026 revierte D27).
 *   · No se nombra ninguna dolencia, ni para decir que no se trabaja.
 *
 * ── LA HISTORIA, SCROLL A SCROLL ──────────────────────────────────────────
 *
 *      1 · gancho          «Tener voz» lo dice todo.            la aspiración
 *      2 · tu-voz          Tu voz trabaja más horas que tú.     el espejo
 *      3 · se-entrena      La voz también se entrena.           el giro
 *      4 · para-quien      Hecha para quien usa la voz a diario. te reconoces
 *      5 · como-funciona   Tu plan, listo en cinco minutos.     la promesa
 *      6 · momento         Cabe en tu día.                      la facilidad (fotos)
 *      7 · asistente       Nunca estás a solas con tu voz.      el acompañamiento
 *      8 · diferenciales   La mejor y más completa plataforma.  por qué nosotros
 *      9 · seguridad       Cuidamos tu voz con criterio.        la tranquilidad
 *     10 · precio          Un año entero para cuidar tu voz.    la decisión
 *     11 · preguntas       Lo que nos preguntan.                las objeciones
 *     12 · cierre          Dale unos minutos.                   el empujón final
 *
 * Los textos de interfaz que no son prosa —menú, botones, el chat de muestra,
 * el pie— viven en el diccionario (`venta.*`), que también pasa por los
 * filtros de jerga, dolencias y frases vetadas.
 *
 * ── 16/09/2026 · PASADA DE IDIOMA: ESTO SE LEE EN LATINOAMÉRICA ───────────
 *
 * El dueño, sobre un texto de la aplicación: «revisa todo en cada idioma, pero
 * pasando a la mentalidad del idioma que vas a validar […] en español, de
 * lanta». Esta página estaba escrita en castellano de España: móvil, ordenador,
 * auriculares, autobús, aula, «en directo», «te devolvemos lo pagado». Y decía
 * dos cosas que no eran verdad:
 *
 *   · «Como cualquier otra parte del cuerpo que usas a diario», que es la
 *     misma frase que él marcó en la portada de la aplicación («cualquier otra
 *     cosa del cuerpo … es ofensivo, es depreciativo») con «cosa» cambiada por
 *     «parte»;
 *   · «Entre cinco y quince minutos», dos veces, cuando el producto ofrece
 *     tres, siete, quince y veinticinco (`TALLAS` en `packages/dominio`). Lo
 *     mismo en inglés y en portugués.
 *
 * El pie legal decía «no es un producto sanitario», que en Colombia y en México
 * es el inodoro. Ahora dice «no es un dispositivo médico»; es texto legal y lo
 * tiene que confirmar el abogado.
 * ═══════════════════════════════════════════════════════════════════════════
 */

import type { Idioma } from "@vc/contenido";

import { EN_TU_PLAN, FICHAS, PREGUNTAS, SILENCIOSAS, SIN_CARGA } from "@vc/contenido/cifras";
import { elCobroEnPesos, PRECIO, FOTOS, type Bloque } from "./precio.ts";
import { BLOQUES_EN, BLOQUES_PT, PIE_EN, PIE_PT } from "./copy-en-pt.ts";

export { elCobroEnPesos, PRECIO, type Bloque };

export const BLOQUES_ES: readonly Bloque[] = [
  {
    id: "gancho",
    /* 16/09: decía «Para quien vive de su voz». El dueño: «mejoremos eso … por algo así: Para quien
       valora su voz». La portada ya no le habla solo a quien trabaja con la voz; eso lo cuenta el
       bloque `para-quien`, que termina en «Y para todos los que valoran su voz». */
    eyebrow: "Para quien valora su voz",
    /* 15/09: decía «Tener voz» con comillas latinas. El dueño: «ese símbolo dice que es hecho por
       IA de lejos, cambia ese símbolo». Van las inglesas, que son las que él escribió en su titular. */
    titulo: "“Tener voz” lo dice todo. Cuida la tuya.",
    cuerpo:
      "Por tu voz te escuchan, te eligen y te recuerdan. Voice Comfort es la mejor y más completa " +
      "plataforma para cuidarla: un plan hecho para ti, unos minutos al día desde el celular y un " +
      "asistente experto en voz siempre a mano.",
    foto: { src: FOTOS.manana, alt: "Una mujer sonríe mirando el celular en la cocina, con una taza de café en la mano." },
  },
  {
    id: "tu-voz",
    eyebrow: "Todos los días",
    titulo: "Tu voz trabaja más horas que tú.",
    cuerpo:
      "Das clase, cierras ventas, diriges reuniones y atiendes una llamada detrás de otra. Todo pasa " +
      "por tu voz, y casi nadie le dedica ni un minuto. Hasta el día en que llega cansada justo " +
      "cuando más la necesitas.",
  },
  {
    id: "se-entrena",
    eyebrow: "La buena noticia",
    titulo: "La voz también se entrena.",
    cuerpo:
      "Igual que entrenas el cuerpo, puedes entrenar la voz. No hace falta cantar ni saber nada de " +
      "voz: basta con saber qué hacer, cuánto y cuándo parar. Eso es lo que te damos.",
    puntos: [
      { titulo: "Qué hacer", texto: "Ejercicios concretos, explicados paso a paso." },
      { titulo: "Cuánto", texto: "El tiempo y las repeticiones justas para tu trabajo y tu día." },
      { titulo: "Cuándo parar", texto: "Un temporizador te marca el final, porque con la voz, más no es mejor." },
    ],
  },
  {
    id: "para-quien",
    eyebrow: "Para quién es",
    titulo: "Hecha para quien usa la voz todos los días.",
    cuerpo: "Cada profesión usa la voz a su manera. Por eso cada plan es distinto.",
    puntos: [
      { titulo: "Docentes y formadores", texto: "Horas de clase, y la última igual de clara que la primera." },
      { titulo: "Atención al cliente y ventas", texto: "Una llamada detrás de otra, con los audífonos puestos." },
      { titulo: "Líderes, abogados y consultores", texto: "Reuniones y presentaciones en las que tu voz tiene que sonar segura." },
      { titulo: "Locutores, creadores de pódcast y de contenido", texto: "Horas de micrófono, con la voz entera hasta el final." },
      { titulo: "Cantantes, actores y doblaje", texto: "Ya calientas antes de actuar. Aquí cuidas también la voz de cada día." },
      { titulo: "Guías, entrenadores e instructores", texto: "Hablar alto, al aire libre y en movimiento." },
      { titulo: "Profesionales de la salud y del cuidado", texto: "Turnos largos y conversaciones que piden calma." },
      { titulo: "Y cualquiera que hable muchas horas", texto: "Si al final del día notas la voz cansada, también es para ti." },
      /*
        16/09 · EL RECTÁNGULO DE ABAJO, pedido del dueño: «Pon un rectángulo de punta a punta en la
        parte de abajo, con algo tipo "Y para todos los que valoran su voz y el poder de
        comunicarse": y acá pones un texto que en resumen dice que es para todos esa plataforma».
        Va como punto `destacado` (lo que `App.tsx` saca de la rejilla y pinta aparte, igual que la
        garantía del precio) para que pase por los filtros de copy, jerga y dolencias.
      */
      {
        titulo: "Y para todos los que valoran su voz y el poder de comunicarse",
        texto:
          "No hace falta que tu trabajo dependa de la voz. En casa, con tus amigos o en el trabajo, " +
          "es con ella como te comunicas. Voice Comfort es para cualquier persona que quiera cuidarla.",
        destacado: true,
      },
    ],
  },
  {
    id: "como-funciona",
    eyebrow: "Cómo funciona",
    titulo: "Tu plan, listo en cinco minutos.",
    cuerpo:
      `De ${FICHAS} ejercicios elegimos los tuyos: entre ${EN_TU_PLAN.min} y ${EN_TU_PLAN.max}, ` +
      "pensados para tu trabajo, tus horas de voz y tu día.",
    puntos: [
      {
        titulo: "Cuéntanos cómo usas tu voz",
        texto: `Tu trabajo, tus horas de voz y ${PREGUNTAS} preguntas de seguridad, cortas y de sí o no.`,
      },
      {
        titulo: "Deja que te escuchemos",
        texto: "Lees una frase en voz alta y haces una sirena suave. Son treinta segundos, y el audio no sale de tu dispositivo.",
      },
      { titulo: "Recibe tu plan", texto: "Tus ejercicios, cuánto de cada uno y cuándo parar." },
      {
        titulo: "Practica unos minutos al día",
        texto: "Si un día tienes la voz cansada o no puedes hacer ruido, la sesión de ese día se adapta.",
      },
    ],
  },
  {
    id: "momento",
    eyebrow: "En cualquier momento",
    titulo: "Cabe en tu día.",
    cuerpo:
      `Unos minutos al día, desde el celular y sin instalar nada. Y ${SILENCIOSAS} ejercicios ` +
      "se hacen sin que nadie te oiga.",
    puntos: [
      { titulo: "De camino", texto: "En el bus o en el tren, con los audífonos.", foto: { src: FOTOS.autobus, alt: "La misma mujer sonríe con el celular en un bus, junto a la ventana." } },
      { titulo: "Antes de clase", texto: "Cinco minutos en el salón, antes de que lleguen todos.", foto: { src: FOTOS.aula, alt: "Sonríe mirando el celular de pie en un salón vacío." } },
      { titulo: "En una pausa", texto: "Entre dos llamadas, sin moverte de la silla.", foto: { src: FOTOS.oficina, alt: "Ríe mirando el celular en su escritorio, con los audífonos de trabajo al cuello." } },
      { titulo: "Antes de una reunión", texto: "En la recepción, mientras esperas a que te llamen.", foto: { src: FOTOS.reunion, alt: "Sonríe con el celular sentada en la recepción de una oficina, vestida para una reunión." } },
      { titulo: "Al terminar el día", texto: "En el sofá, para bajarle el ritmo a la voz con calma.", foto: { src: FOTOS.sofa, alt: "Sonríe con el celular en el sofá, tapada con una manta, por la noche." } },
    ],
  },
  {
    id: "asistente",
    eyebrow: "Siempre a mano",
    titulo: "Nunca estás a solas con tu voz.",
    cuerpo:
      "Un asistente experto en voz que conoce tu plan. Pregúntale a cualquier hora cómo se hace un " +
      "ejercicio, por qué te toca o qué hacer si hoy llegas con la voz cansada.",
    puntos: [
      { titulo: "A cualquier hora", texto: "Antes de una clase, a mitad de la jornada o un domingo por la noche." },
      { titulo: "Con tu plan delante", texto: "Te responde sobre tus ejercicios, no con consejos genéricos." },
      { titulo: "Con información fiable", texto: "Se apoya en la misma biblioteca de ejercicios que tu plan." },
    ],
  },
  {
    id: "diferenciales",
    eyebrow: "Por qué Voice Comfort",
    titulo: "La mejor y más completa plataforma para cuidar tu voz.",
    puntos: [
      { titulo: "Ejercicios con fundamento", texto: "Basados en la práctica profesional de la voz y en estudios publicados." },
      { titulo: "Oyes cómo tiene que sonar", texto: "Los ejercicios con sonido traen un audio de ejemplo en tu idioma." },
      { titulo: "Ves tu voz en vivo", texto: "Mientras practicas, ves tu tono y tu volumen en la pantalla." },
      {
        titulo: "Lecturas que te escuchan",
        texto: "Al leer en voz alta, marcamos en el texto las palabras que se entienden. Tu voz no sale de tu dispositivo.",
      },
      { titulo: "También para los días malos", texto: `${SIN_CARGA} ejercicios que no le piden esfuerzo a tu voz, para cuando la tienes cansada.` },
      { titulo: "Tu avance, a la vista", texto: "Ves las sesiones que llevas y cómo va tu plan." },
    ],
  },
  {
    id: "seguridad",
    eyebrow: "Tu seguridad, primero",
    titulo: "Cuidamos tu voz con criterio.",
    cuerpo:
      `Antes de crear tu plan te hacemos ${PREGUNTAS} preguntas de seguridad. Si alguna respuesta ` +
      "indica que conviene que te vea un profesional, te lo decimos con claridad y te indicamos a " +
      "quién acudir.",
    puntos: [
      { titulo: "Preguntas antes de empezar", texto: "Cortas y de sí o no, para que tu plan parta de cómo está tu voz hoy." },
      { titulo: "Te decimos cuándo consultar", texto: "Si algo necesita la mirada de un profesional, te lo decimos y te indicamos con qué urgencia." },
      { titulo: "Un plan que baja el ritmo", texto: "Si tu voz está cansada, tu plan se vuelve más suave para que sigas practicando con tranquilidad." },
    ],
  },
  {
    id: "precio",
    eyebrow: "Precio",
    titulo: "Un año entero para cuidar tu voz.",
    cuerpo:
      `Todo Voice Comfort por ${PRECIO.moneda} ${PRECIO.lanzamientoUsd} al año.`,
    puntos: [
      { titulo: "Tu plan personalizado", texto: "Hecho para tu trabajo y tu día, y cambia contigo." },
      { titulo: `Los ${FICHAS} ejercicios`, texto: "Explicados paso a paso, con audio de ejemplo en tu idioma." },
      { titulo: "El asistente experto en voz", texto: "Siempre a mano, con tu plan delante." },
      { titulo: "Tu avance, sesión a sesión", texto: "Ves lo que llevas hecho y lo que te toca." },
      { titulo: "Cancela en un clic", texto: "Desde tu cuenta, sin escribir a nadie." },
      /*
        LA GARANTÍA · decisión del dueño, 06/09/2026, repetida el 13/09 y el 15/09 («lo que sí es
        verdad es que damos 14 días de garantía, si la persona cambia de idea, le devolvemos la plata»).

        «SE DA LA GARANTIA DE 14 DIAS, SI LA PERSONA DESISTE, PARA ESO LA PERSONA TIENE QUE ENTRAR
         EN CONTACTO CON EL SOPORTE TECNICO POR WHATSAPP»

        Catorce es MÁS que los siete del artículo 49 del CDC brasileño, que es la ley del contrato
        (`D43`): una garantía comercial encima del derecho legal, nunca en lugar de él. Va en letra
        porque 14 no es una cifra del catálogo (`verificar:copy`).
      */
      {
        titulo: "Garantía de catorce días",
        texto: "Si no es para ti, escríbenos por WhatsApp dentro de los catorce primeros días y te devolvemos tu dinero.",
        destacado: true,
      },
    ],
  },
  {
    id: "preguntas",
    eyebrow: "Preguntas frecuentes",
    titulo: "Lo que nos preguntan antes de empezar.",
    puntos: [
      { titulo: "¿Necesito saber de música o cantar?", texto: "No. Voice Comfort trabaja la voz con la que hablas: la que usas para dar clase, vender o dirigir una reunión." },
      { titulo: "¿Cuánto tiempo al día?", texto: "Tú eliges: tres, siete, quince o veinticinco minutos. El temporizador te marca cuándo parar." },
      { titulo: "¿Y si un día no puedo hacer ruido?", texto: "Lo marcas al empezar y la sesión de ese día se hace con ejercicios en silencio." },
      { titulo: "¿Y si tengo la voz cansada?", texto: "Lo marcas y tu sesión se vuelve más suave. Si algo necesita que lo vea un profesional, te lo decimos." },
      { titulo: "¿Tengo que instalar algo?", texto: "No. Se abre en el navegador del celular o de la computadora." },
      { titulo: "¿En qué idiomas está?", texto: "En español, inglés y portugués, con los audios de ejemplo en cada idioma." },
      { titulo: "¿Cómo funciona la garantía?", texto: "Si en los catorce primeros días decides que no es para ti, nos escribes por WhatsApp y te devolvemos tu dinero." },
      // 16/09/2026: decía «Sí, en un clic desde tu cuenta. Y antes de renovar te avisamos.». Ese aviso no existe;
      // el dueño lo quitó del precio y, preguntado por este, «si».
      { titulo: "¿Puedo cancelar cuando quiera?", texto: "Sí, en un clic desde tu cuenta." },
    ],
  },
  {
    id: "cierre",
    eyebrow: "Empieza hoy",
    titulo: "Tu voz te acompaña todo el día. Dale unos minutos.",
    cuerpo: "Crea tu plan en cinco minutos y empieza a cuidarla hoy mismo.",
  },
];

/**
 * El pie legal. NO es letra pequeña escondida: es lo que hace que todo lo de
 * arriba se pueda decir.
 */
export const PIE_ES =
  "Voice Comfort entrena una habilidad. No es un dispositivo médico, no diagnostica y no reemplaza " +
  "la consulta con un profesional. Cuando algo conviene revisarlo, te lo decimos y te indicamos con " +
  "quién.";

/* ═════════════════════════════════════════════════════════════════════════
   LOS TRES IDIOMAS, TOTALES SOBRE `Idioma`

   `Record<Idioma, ...>` y no `Partial`: si mañana se añade un cuarto idioma,
   esto NO COMPILA hasta que alguien lo escriba.
   ═════════════════════════════════════════════════════════════════════════ */

export const COPY: Readonly<Record<Idioma, { bloques: readonly Bloque[]; pie: string }>> = {
  es: { bloques: BLOQUES_ES, pie: PIE_ES },
  en: { bloques: BLOQUES_EN, pie: PIE_EN },
  pt: { bloques: BLOQUES_PT, pie: PIE_PT },
};
